// extracted by mini-css-extract-plugin
export default {"wrapper":"add-section-button_wrapper__wW+RX","input":"add-section-button_input__UACcA","button":"add-section-button_button__W8iOp"};